__turbopack_context__.v({
  "plenty-conditions-card": "EnforcePlentyPropositionBanner-module-scss-module__I3Tl7a__plenty-conditions-card",
});
